var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-table',{attrs:{"columns":_vm.columns,"create-route":{
              name: 'carts.selection'
          },"filters":_vm.filters,"pagination":true,"repository-func":_vm.repositoryFunc,"select-values":_vm.selectValues,"title":_vm.title,"enable-totals":"","identifier":"cartsTable","selectable":""},scopedSlots:_vm._u([{key:"member-quick-action-template",fn:function({ row }){return [_c('member-quick-action-modal',{attrs:{"id":row.memberId}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }